import { encrypt, decrypt } from "./crypto";
import { ENCRYPTION_KEY } from "./constants";

const P = "fb11_";

export async function saveData(key, data) {
  try {
    const enc = await encrypt(data, ENCRYPTION_KEY);
    if (enc) { localStorage.setItem(P + key, enc); return true; }
    return false;
  } catch { return false; }
}

export async function loadData(key) {
  try {
    const raw = localStorage.getItem(P + key);
    if (!raw) return null;
    return await decrypt(raw, ENCRYPTION_KEY);
  } catch { return null; }
}

export function deleteData(key) { localStorage.removeItem(P + key); }

export async function saveLockout(data) { return saveData("lockout", data); }
export async function loadLockout() { return loadData("lockout"); }
